import React, { useState } from 'react';
import { X } from 'lucide-react';
import useApi from '../../hooks/useApi';

const ChangePasswordModal = ({ onClose, onSuccess }) => {
    const { apiFetch } = useApi();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setError('As senhas não coincidem.');
            return;
        }
        if (newPassword.length < 4) {
            setError('A senha deve ter pelo menos 4 caracteres.');
            return;
        }
        setError('');
        setLoading(true);

        try {
            await apiFetch('/change-password', {
                method: 'PUT',
                body: { newPassword }
            });
            onSuccess();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        // CORREÇÃO: Sem onClick={onClose} no backdrop
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div 
                className="w-full max-w-md p-6 bg-white rounded-lg shadow-xl"
                onClick={e => e.stopPropagation()} // Previne propagação
            >
                <div className="flex items-center justify-between mb-4">
                    <h2 className="text-xl font-bold">Alterar Senha</h2>
                    <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200"><X /></button>
                </div>
                <form onSubmit={handleSubmit} className="space-y-4">
                    {error && <p className="p-2 text-sm text-red-700 bg-red-100 rounded">{error}</p>}
                    <div>
                        <label className="block text-sm font-medium">Nova Senha</label>
                        <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required className="w-full p-2 mt-1 border rounded"/>
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Confirmar Nova Senha</label>
                        <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required className="w-full p-2 mt-1 border rounded"/>
                    </div>
                    <div className="flex justify-end gap-2 pt-2">
                        <button type="button" onClick={onClose} className="px-4 py-2 font-semibold bg-gray-200 rounded-md">Cancelar</button>
                        <button type="submit" disabled={loading} className="px-4 py-2 font-semibold text-white bg-blue-600 rounded-md disabled:bg-blue-300">
                            {loading ? 'A guardar...' : 'Guardar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePasswordModal;